<template>
  <DataTable
    :loading="!header"
    l
    :value="dataArray"
    responsiveLayout="scroll"
    class="p-datatable-sm editable-cells-table"
    :rowClass="hideRow"
  >
    <Column field="section" :header="$t('section')" key="hourcontrol">
      <template #body="slotProps">
        <InputText
          name="section"
          v-model="slotProps.data[slotProps.column.props.field]"
          type="text"
          :placeholder="$t('section')"
          :disabled="true"
          @change="onCellEditComplete(slotProps)"
        />
      </template>
    </Column>
    <Column field="hourcontrol" :header="$t('hourcontrol')" key="hourcontrol">
      <template #body="slotProps">
        <InputText
          name="hourcontrol"
          v-model="slotProps.data[slotProps.column.props.field]"
          type="text"
          :placeholder="$t('hourcontrol')"
          :disabled="true"
          @change="onCellEditComplete(slotProps)"
        />
      </template>
    </Column>
    <Column field="typeO" :header="$t('typeO')" key="typeO">
      <template #body="slotProps">
        <InputNumber
          name="typeO"
          v-model="slotProps.data[slotProps.column.props.field]"
          :placeholder="$t('typeO')"
          @input="onCellEditComplete(slotProps)"
          :useGrouping="true"
          :minFractionDigits="0"
          :maxFractionDigits="2"
          :disabled="
            (slotProps.data.section == 'start' &&
              slotProps.data.useAgt == false) ||
            (slotProps.data.CreateTime && slotProps.data.UpdateTime)
          "
        />
      </template>
    </Column>
    <Column field="typeC" :header="$t('typeC')" key="typeC">
      <template #body="slotProps">
        <InputNumber
          name="typeC"
          v-model="slotProps.data[slotProps.column.props.field]"
          :placeholder="$t('typeC')"
          @input="onCellEditComplete(slotProps)"
          :useGrouping="true"
          :minFractionDigits="0"
          :maxFractionDigits="2"
          :min="0"
          :disabled="
            (slotProps.data.section == 'start' &&
              slotProps.data.useAgt == false) ||
            (slotProps.data.CreateTime && slotProps.data.UpdateTime)
          "
        />
      </template>
    </Column>
    <Column field="typeH" :header="$t('typeH')" key="typeH">
      <template #body="slotProps">
        <InputNumber
          name="typeH"
          v-model="slotProps.data[slotProps.column.props.field]"
          :placeholder="$t('typeH')"
          @input="onCellEditComplete(slotProps)"
          :useGrouping="true"
          :minFractionDigits="0"
          :maxFractionDigits="2"
          :disabled="
            (slotProps.data.section == 'start' &&
              slotProps.data.useAgt == false) ||
            (slotProps.data.CreateTime && slotProps.data.UpdateTime)
          "
        />
      </template>
    </Column>
    <Column field="typeL" :header="$t('typeL')" key="typeL">
      <template #body="slotProps">
        <InputNumber
          name="typeL"
          v-model="slotProps.data[slotProps.column.props.field]"
          :placeholder="$t('typeL')"
          @input="onCellEditComplete(slotProps)"
          :useGrouping="true"
          :minFractionDigits="0"
          :maxFractionDigits="2"
          :disabled="
            (slotProps.data.section == 'start' &&
              slotProps.data.useAgt == false) ||
            (slotProps.data.CreateTime && slotProps.data.UpdateTime)
          "
        />
      </template>
    </Column>
    <Column field="CreateTime" :header="$t('created_date')">
      <template #body="slotProps">
        <DatePicker
          inputMask="99/99/9999"
          momentFormat="DD/MM/YYYY"
          v-model="slotProps.data[slotProps.column.props.field]"
          showTime
          hourFormat="24"
          :disabled="true"
          placeholder="Created Date"
        />
      </template>
    </Column>
    <Column field="CreateBy" :header="$t('created_by')" key="CreateBy">
      <template #body="slotProps">
        <InputText
          name="CreateBy"
          v-model="slotProps.data[slotProps.column.props.field]"
          placeholder="Created By"
          :disabled="true"
        />
      </template>
    </Column>
    <Column field="UpdateTime" :header="$t('edited_date')">
      <template #body="slotProps">
        <DatePicker
          momentFormat="DD/MM/YYYY"
          v-model="slotProps.data[slotProps.column.props.field]"
          showTime
          hourFormat="24"
          :disabled="true"
          placeholder="Edited Date"
        />
      </template>
    </Column>
    <Column field="UpdateBy" :header="$t('edited_by')" key="UpdateBy">
      <template #body="slotProps">
        <InputText
          name="UpdateBy"
          v-model="slotProps.data[slotProps.column.props.field]"
          placeholder="Edited By"
          :disabled="true"
        />
      </template>
    </Column>
  </DataTable>
</template>
<script>
import moment from "moment";
export default {
  props: {
    dataArray: {
      type: Array,
      default: [],
    },
    dataModel: {
      type: Object,
      default: [],
    },
    mode: {
      type: String,
      default: "",
    },
    header: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      timezoneUserOffset: this.$store.getters.getTimezoneOffset,
      userTimeZoneOffset: moment().utcOffset() / 60,
      userTime: moment().format("HH:mm"),
      companyCode: this.$store.getters.getCompanyCode,
    };
  },
  methods: {
    hideRow(data) {
      return data.mode == this.$FORM_MODE_DELETE ? "row-hidden" : null;
    },
    addDetail() {
      var newDetail = this.dataModel;
      newDetail.mode = this.$FORM_MODE_CREATE;
      var det = { ...newDetail };

      this.dataArray.push(det);
    },
    deleteDetail(event) {
      if (event) {
        var detail = this.dataArray[event.index];

        if (detail.mode == this.$FORM_MODE_CREATE)
          this.dataArray.splice(this.dataArray.indexOf(detail), 1);
        else detail.mode = this.$FORM_MODE_DELETE;
      }
    },
    onCellEditComplete(event) {
      //console.log(event)
      this.editDetail(event.index);
    },
    editDetail(index) {
      if (this.dataArray && this.dataArray.length > 0) {
        let m = this.dataArray[index].mode;
        //console.log(m);
        //console.log(this.dataArray[index].mode);
        if (m == this.$FORM_MODE_UNCHANGED) {
          this.dataArray[index].mode = this.$FORM_MODE_EDIT;
        }
      }
    },
    changever(event, e) {
      if (this.dataArray && this.dataArray.length > 0) {
        this.dataArray[event.index].Version = e == null ? "1" : e.id;
      }
    },
  },
  computed: {
    canEdit() {
      return (
        this.mode == this.$FORM_MODE_CREATE || this.mode == this.$FORM_MODE_EDIT
      );
    },
  },
};
</script>
